import CoolantSample from './coolant-sample.column-name.constants';
import Customer from './customer.column-name.constants';
import OilSample from './oil-sample.column-name.constants';
import Unit from './unit.column-name.constants';

export default {
  CoolantSample,
  Customer,
  OilSample,
  Unit,
  buttons: { field: '', title: '', sortable: false },
  createdBy: { field: 'createdBy' },
  isActive: { field: 'isActive', title: 'Active?' },
  isDeleted: { field: 'isDeleted', title: 'Deleted?' },
  modifiedBy: { field: 'modifiedBy' }
};
